import { CommonOrder } from '../modules/common/hooks/useTable'

class SortUtils {
  public static transformSortValues(
    ordering: CommonOrder,
  ): { order: 'asc' | 'desc'; value: string } {
    return {
      order: (ordering?.order?.toLocaleLowerCase() || 'asc') as 'asc' | 'desc',
      value: ordering?.value?.toString() || '',
    }
  }
}

export default SortUtils
